import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { userPasswordReset } from '@bd/bdcore-data/build/User/actions';
import { Redirect } from '@bd/bdcore-named-routes';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import { colors } from '../../styles';

const styles = css`
color: #000000;
  .MainContent {
    padding: 60px 20px;
    max-width: 600px;
  }
  .form-heading {
    font-weight:700;
    color:${colors.color2};
    text-transform: uppercase;
  }
  .ClientLogin_logout {
    width:100%;
    padding-bottom:20px;
  }
  .btn:disabled {
    background-color: ${colors.color8};
    &:hover {
      background-color: ${colors.color8};
      cursor: disabled;
    }
  }
  .PasswordReset_btn {
    background-color: ${colors.color1};
    color: #FFF;
    padding: 10px 30px;
    border-radius: 5px;
    &:hover {
      background-color: ${colors.color1Darker};
    }
  }
  .ClientLogin_resetSuccess {
    padding-top: 15px;
  }
`;

class PasswordResetPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: (new URLSearchParams(window.location.search)).get('key'),
    };
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value,
    });
  }

  render() {
    const { dispatch, page, favoritesUser } = this.props;
    const { password, confirmPassword, token, reset } = this.state;

    if (!token || favoritesUser) {
      return <Redirect name="favorites" />;
    }

    return (
      <div className={styles}>
        <PageWrapper>
          <PageHelmet page={page} />
          <InsideHeader
            title={`${page.meta.name}`}
            background={get(page, 'page_image.contentUrl')}
          />
          <div className="ClientLogin_formSection styled-form container MainContent">
            <h4 className="form-heading GoldText">Reset Password</h4>
            <div className="form-group">
              <label htmlFor="email">New Password</label>
              <input className="form-control" type="password" name="password" onChange={this.handleInput} required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Retype New Password</label>
              <input className="form-control" type="password" name="confirmPassword" onChange={this.handleInput} required />
              {
                password !== confirmPassword &&
                <span>Passwords Must Match</span>
              }
            </div>
            <div className="form-group">
              <button
                onClick={() => {
                  dispatch(userPasswordReset(password, window.atob(token)));
                  this.setState({ reset: true });
                }}
                disabled={password !== confirmPassword && password.length > 2}
                className="Btn Gold PasswordReset_btn"
              >
                Save Password and Login
              </button>
              {
                reset &&
                <div className="ClientLogin_resetSuccess">Your password has been successfully reset!</div>
              }
            </div>
          </div>
        </PageWrapper>
      </div>
    );
  }
}

PasswordResetPage.propTypes = {
  page: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  favoritesUser: PropTypes.object,
};

PasswordResetPage.defaultProps = {
  favoritesUser: undefined,
};

export default withData(
  {
    favoritesUser: true,
    page: 'hoa_portal',
  },
  {
    required: {
      page: true,
    },
  },
)(PasswordResetPage);



// WEBPACK FOOTER //
// ./src/pages/PasswordReset/index.js